import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import {
  BrowserControlCommunicationService,
  GmSltService,
  ServiceVisitRecordService,
} from '@applications/sha-services';
import { Actions } from '@ngrx/effects';
import { ApiService } from '@quorum/api';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';
import { FadeInOut } from '@quorum/sha-animations';
import { FixedOperationsStateService } from '@quorum/xsr-fixed-operations/services';
import { LabourOperationsStateService } from '@quorum/xsr-labour-operations/services';
import { InspectionService } from '@quorum/xsr-legacy-vip/services';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { VehicleMaintenanceStateService } from '@quorum/xsr-vehicle-maintenance/services';
import { VehicleStateService } from '@quorum/xsr-vehicle/services';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'xsr-no-toolbar-menu',
  templateUrl: './no-toolbar-menu.component.html',
  styleUrls: ['./no-toolbar-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    FadeInOut,
    trigger('flyOutIn', [
      state(
        'shrink',
        style({
          display: 'none',
          flex: 0,
          transform: 'translateX(-160%)',
        })
      ),
      state(
        'full',
        style({
          display: 'flex',
        })
      ),
      transition('full => shrink', animate('138ms ease-in')),
      transition('shrink => full', animate('138ms ease-out')),
    ]),
    trigger('flyInOut', [
      state(
        'full',
        style({
          'box-sizing': 'border-box',
          flex: '1 1 100%',
          display: 'flex',
          width: '28%',
          'max-width': '28%',
        })
      ),
      state(
        'shrink',
        style({
          'box-sizing': 'border-box',
          flex: '1 1 100%',
          display: 'flex',
          width: '100%',
          'max-width': '100%',
        })
      ),
      transition('full => shrink', animate('138ms ease-in')),
      transition('shrink => full', animate('138ms ease-out')),
    ]),
  ],
})
export class NoToolbarMenuComponent extends MenuComponent implements OnInit {
  constructor(
    public activatedRoute: ActivatedRoute,
    public authenticationStateService: AuthenticationStateService,
    public iconRegistry: MatIconRegistry,
    public sanitizer: DomSanitizer,
    public sgService: LabourOperationsStateService,
    public vehicleService: VehicleStateService,
    public vmService: VehicleMaintenanceStateService,
    public changeDetector: ChangeDetectorRef,
    public dialog: MatDialog,
    public fixedOperationsService: FixedOperationsStateService,
    public snackBar: MatSnackBar,
    public apiService: ApiService,
    public systemControlStateService: SystemControlStateService,
    public serviceLaneFacade: ServiceLaneFacade,
    public elementRef: ElementRef,
    public actions$: Actions,
    public browserControlService: BrowserControlCommunicationService,
    public gmSltService: GmSltService,
    public inspectionService: InspectionService,
    public serviceVisitRecordService: ServiceVisitRecordService
  ) {
    super(
      activatedRoute,
      authenticationStateService,
      iconRegistry,
      sanitizer,
      sgService,
      vehicleService,
      vmService,
      changeDetector,
      dialog,
      fixedOperationsService,
      snackBar,
      apiService,
      systemControlStateService,
      elementRef,
      serviceLaneFacade,
      actions$,
      browserControlService,
      gmSltService,
      inspectionService,
      serviceVisitRecordService
    );
  }

  ngOnInit() {
    this.init();
    this.registerInspectionIcons();
  }

  registerInspectionIcons() {
    this.iconRegistry.addSvgIcon(
      `maintenance`,
      this.sanitizer.bypassSecurityTrustResourceUrl(`assets/menu-icons/maintenance.svg`)
    );
  }
}
